<template>
  <div v-loading.fullscreen.lock="fullscreenLoading"></div>
</template>

<script>
export default {
  data() {
    return {
      fromUrl: this.$route.query.fromUrl || '',
      enterpriseId: this.$route.query.enterpriseId || '',
      fullscreenLoading: true,
    }
  },
  async mounted() {
    const { lang } = this.$route.query
    if (lang) {
      localStorage.setItem('locale', lang)
      this.$i18n.locale = lang
    }
    this.checkLogin()
  },
  methods: {
    setCookie(name, value, iDay) {
      /*当时间参数存在的时候*/
      if (iDay) {
        /*设置过期时间*/
        var oDate = new Date()
        oDate.setDate(oDate.getDate() + iDay)
        document.cookie = name + '=' + value + ';path=/;expires=' + oDate
      } else {
        /*否者默认浏览器关闭过期*/
        document.cookie = name + '=' + value + ';path=/;'
      }
    },
    async checkLogin() {
      try {
        const { data } = await this.$http.post(
          `${this.fromUrl}/sso-web/checkLogin`
        )
        const authCode = data?.data || ''
        sessionStorage.setItem('authCode', authCode)
        this.setCookie('llskjorg', this.enterpriseId)
        this.chooseFinal()
      } catch (error) {
        this.fullscreenLoading = false
      }
    },
    //最终选择企业进入
    async chooseFinal() {
      try {
        const { data } = await this.$http.get(
          `/kj-web/sys/setOrgId?orgId=${this.enterpriseId}`
        )
        if (data?.code === '200') {
          await this.getMenu()
        } else {
          this.handleAuthError(data?.message)
        }
      } catch (error) {
        this.handleAuthError(error.message)
      }
    },
    //请求菜单判断是否有权限
    async getMenu() {
      try {
        const { data } = await this.$http.post(
          '/kj-web/sys/getUserMenuTreeList',
          { sysChannel: 'kj_my' }
        )
        this.fullscreenLoading = false

        const tl = data?.data || []
        this.$router.replace(tl.length === 0 ? '/login' : '/home?isReFlag=2')
      } catch (error) {
        this.fullscreenLoading = false
      }
    },
    handleAuthError(message) {
      this.fullscreenLoading = false
      this.$router.replace('/login')
      this.$alert(message, '提示', {
        confirmButtonText: '确定',
      })
    },
  },
}
</script>
